export default "__VITE_ASSET__DfYadSx5__"